// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__7kPS_","default":"Button_default__TyVq6","icon":"Button_icon__5RXOK"};